
export class LoginGanador {
    correo: string;
    password:string;
    tipo_ganador:string;
}
